
import fetch from '@/common/js/http';

const eteamChance = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {

    // 获取所有eteams商机
    getEteamsChanceAll({ commit }, {params}) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: 'eteamsChance/all',
          method: 'get',
          params: params
        }).then(success => {
          resolve(success)
        }, error => {
          reject(error)
        })
      })
    },// 获取所有eteams商机合同
    getEteamsContractByEteamsId({ commit }, {params}) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: 'eteamsContract',
          method: 'get',
          params: params
        }).then(success => {
          resolve(success)
        }, error => {
          reject(error)
        })
      })
    },
  }
}
export default eteamChance



// WEBPACK FOOTER //
// ./src/vuex/modules/eteamChance.js